module.exports = __webpack_public_path__ + "img/ss_blue-01.a3f2d474.jpg";